<nav class='breadcrumbs' aria-label='Ścieżka okruszków'>
  <ul>
    <li>
      <a
        class='home'
        routerLink='/'
        aria-label='Strona główna'></a>
    </li>
    <ng-content></ng-content>
  </ul>
</nav>
